import React, { useEffect } from 'react';

import { Button, Icon } from 'components';
import { capitalize } from 'utils';
import { useHistory } from 'react-router-dom';

import Searchbar from './Searchbar';
import { TeamGroupModalContext } from '../TeamGroupModal/TeamGroupModalContext';
import ManageUsersContext from '../ManageUsersContext';
import { StyledHeaderActions } from '../StyledComponents';

const TeamGroupHeader: React.FC<{
  md: boolean;
  type: 'group' | 'team';
}> = ({ md, type }) => {
  const { setSearchText, searchText } = React.useContext(ManageUsersContext);
  const history = useHistory();

  const textChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  };

  const { openModal } = React.useContext(TeamGroupModalContext);

  useEffect(() => {
    const searchParams = new URLSearchParams(history.location.search);
    const searchTeam = searchParams.get('searchTeam');
    const teamId = searchParams.get('teamId');
    if (searchTeam && teamId) {
      history.location.search = '';
      openModal('team', 'edit', teamId);
      setSearchText(searchTeam);
    }
  }, [history, openModal, setSearchText]);

  return (
    <StyledHeaderActions wrap $md={md}>
      <Searchbar
        allowClear
        placeholder={`Search ${capitalize(type)}s`}
        value={searchText}
        onChange={textChangeHandler}
        suffix={<Icon type="search" color="gray5" />}
        data-cy={`${type}-input`}
      />
      <Button
        onClick={() => openModal(type, 'add')}
        type="primary"
        icon={<Icon type="plus" color="white" width={20} height={20} />}
        style={{ display: 'flex' }}
        data-cy={`add-${type}`}
      >
        Add {capitalize(type)}
      </Button>
    </StyledHeaderActions>
  );
};

export default TeamGroupHeader;
